import React, { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

import SUTextField from '../../Components/SUTextField';
import NodeEditorChrome from '../../Components/NodeEditorChrome';
import { NODE_THEMES } from '../../Components/NodeTheme';
import TriggerTypeField from '../../Components/TriggerTypeField';
import { InfoCallout } from '../../Components/NodeFormKit';
import useNodeEditor from '../../Components/useNodeEditor';

import styledComponent from 'styled-components';
import Select from 'react-select';

import { TiFlowMerge } from 'react-icons/ti';

const FLOWS_NODE_COLOR = '#B85C7C';

const FlowsWhatsApp = ({
  selectedNode,
  handleSelectedNode,
  removeNode,
  nodes,
  edges,
  editFlow,
  updateBot,
  truncateText,
  customStyles,
  customStylesDark,
  isDark,
  flows,
  watchSelectedNode,
  onMouseDown,
  isDragging,
  isExpanded,
  setIsExpanded,
}) => {
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    user_response: null,
  });

  const { handleInputChange, loadData, saveNode, getIsDirty } = useNodeEditor({
    selectedNode,
    handleSelectedNode,
    nodes,
    edges,
    editFlow,
    updateBot,
    reset,
    getValues,
  });

  const [errorFlow, setErrorFlow] = useState(false);

  // ------> Selects, Radios, Checkbox
  const theme = isDark == 'true' ? NODE_THEMES.dark : NODE_THEMES.light;
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  // FUNCTIONS

  //# Function para manejar cambios de estados de campos

  //# Function para guardar los datos
  const saveData = (values) => {
    if (!selectedNode.data.flow) {
      setErrorFlow(true);
      return;
    }

    setLoadingUpdate(true);

    const data = {
      title: values.title,
      user_response: values.user_response,
      trigger_type: selectedNode.data?.trigger_type || 'message',
      flow_data: {
        header: values.flow_header,
        body: values.flow_body,
        footer: values.flow_footer,
        button: values.flow_button,
      },
    };

    saveNode(data, () => {
      setLoadingUpdate(false);
    });
  };

  //# Function para obtner data
  const getData = () => {
    let objectData = {
      title: selectedNode.data?.title ?? null,
      user_response: selectedNode.data?.user_response ?? null,
      trigger_type: selectedNode.data?.trigger_type ?? 'message',
      flow_header: selectedNode.data.flow_data?.header ?? null,
      flow_body: selectedNode.data.flow_data?.body ?? null,
      flow_footer: selectedNode.data.flow_data?.footer ?? null,
      flow_button: selectedNode.data.flow_data?.button ?? null,
    };
    loadData(objectData);
  };

  useEffect(() => {
    getData();
  }, [watchSelectedNode]);

  return (
    <NodeEditorChrome
      icon={TiFlowMerge}
      color={FLOWS_NODE_COLOR}
      typeName="Flujo WhatsApp"
      title={truncateText(selectedNode.data.title)}
      onRemove={() => removeNode(selectedNode.id)}
      onMouseDown={onMouseDown}
      isDragging={isDragging}
      onClose={() => handleSelectedNode(null)}
      formId="flowsWhatsAppForm"
      saving={loadingUpdate}
      isDark={isDark}
      getIsDirty={getIsDirty}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
    >
        <form id="flowsWhatsAppForm" onSubmit={handleSubmit(saveData)} style={{ width: '100%' }}>
          <div>
            <div className="col p-0">
              <SUTextField
                id="title"
                name="title"
                label="Título:"
                type="text"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('title', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
            <div className="col p-0 mt-4">
              <TriggerTypeField
                value={selectedNode.data?.trigger_type}
                handleInputChange={handleInputChange}
                isDark={isDark}
                customStyles={customStyles}
                customStylesDark={customStylesDark}
              />
            </div>
            <div className="col p-0 mt-4">
              <SUTextField
                id="user_response"
                name="user_response"
                label="Respuesta del cliente:"
                hint="Lo que debe llegar para activar este nodo: el texto que escribe el cliente, el título de un botón, o * para cualquier respuesta. Para varios, separalos con  /  ."
                type="textArea"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('user_response', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />

              <InfoCallout title="Importante:">
                Con el signo * funciona para cualquier respuesta que dé el
                cliente. Para varias respuestas, separalas con el formato
                Respuesta 1 / Respuesta 2 / Respuesta 3.
              </InfoCallout>
            </div>
            <div className="col p-0 mt-4">
              <label>Flujos: </label>
              <div className="su-control-group d-flex">
                <Select
                  styles={isDark == 'true' ? customStylesDark : customStyles}
                  className="form-control basic-multi-select"
                  placeholder="Seleccione..."
                  name="flows"
                  value={
                    flows.find(
                      (option) => option._id === selectedNode.data.flow
                    ) || ''
                  }
                  onChange={(flow) => {
                    handleInputChange('flow', flow._id);
                    setErrorFlow(false);
                  }}
                  options={flows}
                  classNamePrefix="select"
                  noOptionsMessage={() => 'Sin opciones'}
                  getOptionLabel={(option) => (
                    <div className="option d-flex" style={{ fontSize: '15px' }}>
                      {option.name}
                    </div>
                  )}
                  getOptionValue={(option) => option._id}
                />
              </div>

              {errorFlow && <Alert>* Campo requerido</Alert>}
            </div>
            {selectedNode.data.flow && (
              <>
                <div className="col p-0 mt-4">
                  <label
                    htmlFor="header"
                    style={{
                      color: theme.textSecondary,
                      fontWeight: 500,
                    }}
                  >
                    Encabezado (Opcional):{' '}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      id="header"
                      name="header"
                      type="text"
                      style={{
                        width: '100%',
                        height: '35px',
                      }}
                      {...register('flow_header', {
                        pattern: {
                          value: /\S+/,
                          message: 'No puede ser solo espacios en blanco',
                        },
                      })}
                    />
                    <p
                      style={{
                        fontSize: 12,
                        color: theme.textSecondary,
                        fontWeight: 500,
                      }}
                    >
                      Encabezado para enviar el flujo.
                    </p>
                  </div>
                  <SUTextField
                    id="flow_header"
                    name="flow_header"
                    label="Encabezado (Opcional):"
                    maxLength={60}
                    type="text"
                    hint="Encabezado para enviar el flujo."
                    selectedNode={selectedNode}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    {...register('flow_header', {
                      pattern: {
                        value: /\S+/,
                        message: 'No puede ser solo espacios en blanco',
                      },
                    })}
                  />
                </div>
                <div className="col p-0">
                  <SUTextField
                    id="flow_body"
                    name="flow_body"
                    label="Cuerpo:"
                    maxLength={1024}
                    type="text"
                    hint="Cuerpo para enviar flujo."
                    selectedNode={selectedNode}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    {...register('flow_body', {
                      required: {
                        value: selectedNode.data.flow ? true : false,
                        message: 'Campo requerido.',
                      },
                      pattern: {
                        value: /\S+/,
                        message: 'No puede ser solo espacios en blanco',
                      },
                    })}
                  />
                </div>
                <div className="col p-0">
                  <SUTextField
                    id="flow_footer"
                    name="flow_footer"
                    label="Pie:"
                    maxLength={60}
                    type="text"
                    hint="Pie para enviar flujo."
                    selectedNode={selectedNode}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    {...register('flow_footer', {
                      required: {
                        value: selectedNode.data.flow ? true : false,
                        message: 'Campo requerido.',
                      },
                      pattern: {
                        value: /\S+/,
                        message: 'No puede ser solo espacios en blanco',
                      },
                    })}
                  />
                </div>
                <div className="col p-0">
                  <SUTextField
                    id="flow_button"
                    name="flow_button"
                    label="Título de Botón:"
                    maxLength={20}
                    type="text"
                    hint="Título de botón para enviar flujo (Máx 20)."
                    selectedNode={selectedNode}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    {...register('flow_button', {
                      required: {
                        value: selectedNode.data.flow ? true : false,
                        message: 'Campo requerido.',
                      },
                      pattern: {
                        value: /\S+/,
                        message: 'No puede ser solo espacios en blanco',
                      },
                    })}
                  />
                </div>
              </>
            )}
          </div>
        </form>
    </NodeEditorChrome>
  );
};

export default FlowsWhatsApp;

const Alert = styledComponent.span`
  color: red;
  display: block;
  width: 100%;
  // width: 200px;
`;
